import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clear-field"
export default class extends Controller {
  static targets = [ "field" ]

  clear() {
    console.log("clearing field");
    this.fieldTarget.value = null;
  }
}
